import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ConnectJobModel, JobFiltersModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { IJobsService } from "services/JobsService";

const initialState = {
  Jobs: new Array<ConnectJobModel>(),
  IncludeArchived: false,
  LoadingJobs: false,
};

export const jobsTableSlice = createSlice({
  name: "jobs",
  initialState,
  reducers: {
    setIncludeArchived: (state, action) => {
      state.IncludeArchived = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getJobs.pending, (state) => {
        state.LoadingJobs = true;
      })
      .addCase(getJobs.fulfilled, (state, action) => {
        state.Jobs = action.payload;
        state.LoadingJobs = false;
      })
      .addCase(getJobs.rejected, (state) => {
        state.LoadingJobs = false;
      });
  },
});

export const { setIncludeArchived } = jobsTableSlice.actions;

export const getJobs = createAsyncThunk("jobs/GetJobs", async (includeArchived: boolean) => {
  const jobsService = container.get<IJobsService>(SERVICE_TYPES.JobsService);
  return await jobsService.getJobs(new JobFiltersModel({ includeArchived }));
});

export const selectJobs = (state: RootState) => state.jobs.Jobs;
export const selectIncludeArchived = (state: RootState) => state.jobs.IncludeArchived;
export const selectLoadingJobs = (state: RootState) => state.jobs.LoadingJobs;

export default jobsTableSlice.reducer;
